//export const BaseUrl = 'http://localhost:5000/api/v2';
//export const media = "http://localhost:5000/";
//export const mealUrl="http://localhost:5000/MealDetails/"
export const BaseUrl = 'https://api.HayakomRestaurant.com/api/v2';
export const media = "https://api.HayakomRestaurant.com/";
export const mealUrl="https://HayakomRestaurant.com/MealDetails/"